import { useStoreRequired } from 'features/store/hooks/use-store-required';

import { MenuTabsWrap } from 'pages/menu/components/menu-tabs';
import { MenuRecentItemsPage } from 'pages/menu/recent-items-page';

export default function MenuScreen() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <MenuRecentItemsPage />
    </MenuTabsWrap>
  );
}
